/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars, no-console */
import { Injectable } from '@angular/core';
import moment from 'moment';
import { Observable } from 'rxjs';
import { EnvSpecific } from '../_models';
import { EnvironmentSpecificService } from '../modules/core/services/env-specific.service';

@Injectable()
export class Logger {
  constructor(private env: EnvironmentSpecificService) {
    this.envData = env.getEnv();
  }

  private envData: Observable<EnvSpecific>;

  public static readonly OFF: number = 0;
  public static readonly FATAL: number = 1;
  public static readonly ERROR: number = 2;
  public static readonly WARN: number = 3;
  public static readonly INFO: number = 4;
  public static readonly DEBUG: number = 5;
  public static readonly TRACE: number = 6;
  public log(message: any[], errorLevel: number = Logger.INFO): void {
    if (this.env.envSpecific.loggerThreshold < errorLevel) return;
    let color;
    const time = moment();
    switch (errorLevel) {
      case Logger.TRACE:
        color = 'green';
        console.log(`%c${this._timestamp()} Trace:`, `color:${color}`, ...message);
        break;
      case Logger.INFO:
        color = 'teal';
        console.log(`%c${this._timestamp()} Info:`, `color:${color}`, ...message);
        break;
      case Logger.DEBUG:
        color = 'blue';
        console.log(`%c${this._timestamp()} Debug:`, `color:${color}`, ...message);
        break;
      case Logger.WARN:
        console.warn(`${this._timestamp()} WARNING:`, ...message);
        break;
      case Logger.ERROR:
        color = 'black';
        console.error(`%c${this._timestamp()} ERROR:`, `color:${color}`, ...message);
        // this.ravenErrorHandler.handleError(message);
        break;
      case Logger.FATAL:
        console.error(`${this._timestamp()} FATAL:`, ...message);
        // this.ravenErrorHandler.handleError(message);
        break;
      default:
        console.warn('Unknown error level');
        console.log(...message);
    }
  }

  private _timestamp(): string {
    return moment().format('YYYY-MM-DD HH:mm:ss.SS');
  }
  public trace(...message: any[]): void {
    return this.log(message, Logger.TRACE);
  }
  public debug(...message: any[]): void {
    return this.log(message, Logger.DEBUG);
  }
  public info(...message: any[]): void {
    return this.log(message, Logger.INFO);
  }
  public warn(...message: any[]): void {
    return this.log(message, Logger.WARN);
  }
  public error(...message: any[]): void {
    return this.log(message, Logger.ERROR);
  }
  public fatal(...message: any[]): void {
    return this.log(message, Logger.FATAL);
  }

  // static methods allowed for error and fatal, since those will always be displayed
  public static error(...message: any[]): void {
    const color = 'black';
    console.error(`%c${moment().format('YYYY-MM-DD HH:mm:ss.SS')} ERROR:`, `color:${color}`, ...message);
  }
  public static fatal(...message: any[]): void {
    console.error(`${moment().format('YYYY-MM-DD HH:mm:ss.SS')} FATAL:`, ...message);
  }
}
